/**
 * The element the app actually scrolls.
 *
 * ⚠️ ON A PHONE THE WINDOW NEVER SCROLLS. The phone shell is a fixed frame and
 * `main.mobile-shell__content` is its only scroller (`mobile-shell.scss`), so `window.scrollY` is
 * pinned at 0 and `window.scrollTo` does nothing there. Anything that reads or restores the page's
 * scroll position must go through these helpers. On desktop (and the blank/auth layouts) they fall
 * through to the window, unchanged.
 */

/** Toggled on `<html>` by `DefaultLayoutWithVerticalNav` while the phone shell renders. */
export const MOBILE_SHELL_ACTIVE_CLASS = "mobile-shell-active";

const SHELL_SCROLLER_SELECTOR = "main.mobile-shell__content";

export function isMobileShellActive(): boolean {
  return typeof document !== "undefined"
    && document.documentElement.classList.contains(MOBILE_SHELL_ACTIVE_CLASS);
}

/** The phone shell's `main` when it is active, otherwise `null` (meaning: the window). */
export function getShellScroller(): HTMLElement | null {
  if (!isMobileShellActive())
    return null;

  return document.querySelector<HTMLElement>(SHELL_SCROLLER_SELECTOR);
}

/** The scroller as something `addEventListener` / VueUse `useScroll` accept. */
export function getAppScroller(): HTMLElement | Window {
  return getShellScroller() ?? window;
}

export function getAppScrollTop(): number {
  const shell = getShellScroller();

  return shell ? shell.scrollTop : window.scrollY;
}

export function appScrollTo(options: ScrollToOptions): void {
  const shell = getShellScroller();

  if (shell)
    shell.scrollTo(options);
  else
    window.scrollTo(options);
}
